import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import { IoIosArrowForward } from 'react-icons/io'
import './contratotable.css'
import { warning } from "../../../../../utils/notifications"
import { EditModalDialog } from "../ProveedorTable/EditModalDialog/EditModalDialog"
import { diferencialEuroRenderer, diferencialKgRenderer } from "../../../../../utils/helperFunctions"
import { UserContext } from "../../../../../Redux/UserContext"

export const ContratoTable:FC<any> = (props) => {

    const { data, dataMASTER, setData, simulated,original, setStep, selectedProvider, comparativa, saveLoading, same, scenarioBase } = props

    const [state] = useContext(UserContext)

    const gridRef :any= useRef();

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }

   

    const handleRowClassRules = {
        'var(--lis-dark)-row' : (params:any) => params.data.data_from === 'Base',
        'var(--lis-alternative)-row' : (params:any) => params.data.data_from === 'Comparision'
    }


    const handleBackProviders = () => {
        setStep(true)
    }

    const handleEditCellContent = (params:any) => {
        let { colId } = params.column
        if(colId !== 'name_contract' && colId !== 'name_provider') {
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            } else {
                if(simulated.scenario_comparision) {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
    
                } else {
                    setSelectedCell(colId)
                    setSelectedRow(params.data)
                    setVisible(true)
                }
            }
        }
        
        
    }

    const handleCellStyleEditable = (params:any) => {
        let original = dataMASTER.contract_table.find((ori:any) => ori.id_contract === params.data.id_contract)?.[params.column.colId]

        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',border:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',border:'1px solid #dee2e6'}
        } 
    }

    const handleCellStyle = (params:any) => {
        let original = dataMASTER.contract_table.find((ori:any) => ori.id_contract === params.data.id_contract)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    const joinContracts = () => {
        let aux = data.contract_table.filter((ct:any) => ct.name_provider === selectedProvider.name_provider)
        let nuevo_aux:any[] = []
    
        aux.map((a:any) => {
            let provcontr = nuevo_aux.map((na:any) => `${na.name_provider}${na.name_contract}`)
            
            if(provcontr.includes(`${a.name_provider}${a.name_contract}`)) {
               
                let indice = provcontr.indexOf(`${a.name_provider}${a.name_contract}`)
                
                if(nuevo_aux[indice]['cantidad_a'] === null && nuevo_aux[indice]['precio_a'] === null) {
                    nuevo_aux[indice]['cantidad_a'] = a.cantidad_a
                    nuevo_aux[indice]['precio_a'] = a.precio_a
                } else {
                    nuevo_aux[indice]['cantidad_b'] = a.cantidad_b
                    nuevo_aux[indice]['precio_b'] = a.precio_b
                }
            } else {
                nuevo_aux.push(a)
            }
        })
        return nuevo_aux
    }
    

    return (
        <div className="contratotable__wrapper">
            <EditModalDialog
                visible={visible}
                setVisible={setVisible}
                handleClose={handleClose}
                selectedCell={selectedCell}
                setSelectedCell={setSelectedCell}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                mode={mode}
                setMode={setMode}
                data={data}
                dataMASTER={dataMASTER}
                setData={setData}
                type={"C"}
                
            />
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
            <div className="contrato_back_btn">
                <span style={{cursor:'pointer'}} onClick={handleBackProviders}>Proveedores</span>
                <IoIosArrowForward style={{marginLeft:5,marginBottom:2}} />
                <span>{selectedProvider.name_provider}</span>
                <IoIosArrowForward style={{marginLeft:5,marginBottom:2}} />
                <span><b>Contratos</b></span>
            </div>
            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '100%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '100%' }}>
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContent : () => warning("No tienes permisos para realizar esta acción")}
                    rowClassRules={handleRowClassRules}
                    rowData={joinContracts()}
                    enableCellTextSelection>
                    <AgGridColumn sort={'desc'} resizable={true} flex={1} hide  field={"id"}></AgGridColumn>
                    <AgGridColumn suppressNavigable={true} sortable hide  flex={1}  headerClass={"header-resize"}  headerName={"ID Contrato"} field={"id_contract"}></AgGridColumn>
                    <AgGridColumn sortable  cellStyle={handleCellStyle} headerClass={"header-resize"}  suppressNavigable={true} flex={1}  headerName={"Contrato"} field={"name_contract"}></AgGridColumn>
                    <AgGridColumn sortable cellStyle={handleCellStyle} headerClass={"header-resize"}  suppressNavigable={true} flex={1}  headerName={"Proveedor"} field={"name_provider"}></AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Cantidad" flex={1}>
                        <AgGridColumn cellStyle={handleCellStyleEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} suppressNavigable flex={1} cellRenderer={diferencialKgRenderer}   headerName="Esc A" field="cantidad_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleEditable} sortable headerClass={"var(--lis-alternative)-column header-resize"} suppressNavigable flex={1} cellRenderer={diferencialKgRenderer} hide={!comparativa}   headerName="Esc B" field="cantidad_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Precio" flex={1}>
                        <AgGridColumn cellStyle={handleCellStyleEditable} sortable headerClass={"var(--lis-dark)-column header-resize"} suppressNavigable flex={1} cellRenderer={diferencialEuroRenderer}   headerName="Esc A" field="precio_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleEditable} sortable headerClass={"var(--lis-alternative)-column header-resize"} suppressNavigable flex={1} cellRenderer={diferencialEuroRenderer} hide={!comparativa}   headerName="Esc B" field="precio_b"></AgGridColumn>
                    </AgGridColumn>


                </AgGridReact>
            </div>
        </div>
        
    )
}